<template>
  <div class="count-down-component">
    <img :src="blockBgImg" alt="" class="block-bg-img">
    <div class="info">
      <div class="item">
        <div class="text">仅剩</div>
      </div>
      <div class="item"
           v-if="showDays"
      >
        <span class="time"
              :style="style"
        >
          {{ timerData.days[0] }}
        </span>
        <span class="time"
              :style="style"
        >
          {{ timerData.days[1] }}
        </span>
        <div class="text">天</div>
      </div>
      <div class="item">
        <span class="time"
              :style="style"
        >
          {{ timerData.hours[0] }}
        </span>
        <span class="time"
              :style="style"
        >
          {{ timerData.hours[1] }}
        </span>
        <div class="text">时</div>
      </div>
      <div class="item">
        <span class="time"
              :style="style"
        >
          {{ timerData.minutes[0] }}
        </span>
        <span class="time"
              :style="style"
        >
          {{ timerData.minutes[1] }}
        </span>
        <div class="text">分</div>
      </div>
      <div class="item"
           v-if="!showDays"
      >
        <span class="time"
              :style="style"
        >
          {{ timerData.seconds[0] }}
        </span>
        <span class="time"
              :style="style"
        >
          {{ timerData.seconds[1] }}
        </span>
        <div class="text">秒</div>
      </div>
    </div>
  </div>
</template>

<script>
  import CountDown from '@/utils/count-down';

  export default {
    name: 'CountDown',
    data() {
      return {
        timerData: {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00',
        },
      };
    },
    props: {
      start: {
        type: Number,
        required: true,
      },
      end: {
        type: Number,
        required: true,
      },
      blockBgImg: {
        type: String,
        required: true,
      },
      itemBgImg: {
        type: String,
      },
      itemColor: {
        type: String,
      },
      contentWidth: {
        type: String,
      },
    },
    computed: {
      showDays() {
        return parseInt(this.timerData.days, 10) > 0;
      },
      itemStyle() {
        const result = {};
        result.background = this.itemBgImg ? `url('${this.itemBgImg}') no-repeat` : '#fff';
        result['background-size'] = 'contain';
        if (this.itemColor) {
          result.color = this.itemColor;
        }
        return result;
      },
      style() {
        const result = {};
        if (this.contentWidth === '100%') {
          result['margin-left'] = '10px';
          result['margin-right'] = '10px';
          return Object.assign(result, this.itemStyle);
        }
        result.width = this.fetchItemSize(76, this.contentWidth);
        result.height = this.fetchItemSize(118, this.contentWidth);
        result['margin-left'] = this.fetchItemSize(10, this.contentWidth);
        result['margin-right'] = this.fetchItemSize(10, this.contentWidth);
        return Object.assign(result, this.itemStyle);
      },
    },
    methods: {
      fetchItemSize(baseWidth, contentWidth) {
        const width = parseInt(contentWidth, 10);
        const realWidth = ((baseWidth * width) / 1100);
        return `${realWidth}px`;
      },
      initCountDown() {
        new CountDown({
          startTime: this.start,
          endTime: this.end,
          render: (data) => {
            this.timerData = data;
          },
          end: () => {
            this.$emit('countDownEnded');
          },
        });
      },
    },
    created() {
      this.initCountDown();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .count-down-component {
    line-height: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .block-bg-img {
    max-width: 100%;
  }

  .info {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 20%;
    display: flex;
    justify-content: center;
  }

  .item {
    display: flex;
    align-items: flex-end;
    font-size: @font-size-base;
    color: @color-black-light;
    position: relative;
    z-index: 2;
  }

  .text {
    padding-bottom: @size-base;
  }

  .time {
    width: 76px;
    height: 118px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    border-radius: @border-radius-normal;
    color: @color-black-light;
    background-size: contain;
    font-size: 64px;
    font-weight: @font-weight-bold;
  }
</style>
